<template>

  <v-container fluid>
    
    <!-- 추가/수정 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog" @keydown.esc="close" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{ dialogTitle }}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <v-container>

              <v-row dense class="mb-5"> 
                <v-menu
                  v-model="date1"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="editedIndex > -1"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.DAYDATE"
                      :label="$t('edpoint_label1')" 
                      prepend-icon="event"
                      readonly outlined dense hide-details
                      :disabled="editedIndex > -1"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="editedItem.DAYDATE" @input="date1 = false" :first-day-of-week="0" :locale="$i18n.locale"></v-date-picker>
                </v-menu>      
              </v-row>
              
              <v-row dense>
                <v-text-field v-model="editedItem.POINT" :label="$t('edpoint_col2')" outlined></v-text-field>
              </v-row>
              <v-row dense>
                <v-text-field v-model="editedItem.POINTPERMIN" :label="$t('edpoint_col3')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.DAYMAX" :label="$t('edpoint_col4')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.POINTMAX" :label="$t('edpoint_col6')" outlined></v-text-field>
              </v-row>
              <v-row dense> 
                <v-text-field v-model="editedItem.ESSENMAX" :label="$t('edpoint_col5')" outlined></v-text-field>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large  @click="close">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large  @click="save">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row align="center" justify="start" dense>
      <v-col cols="12" md="3" sm="6" xs="12">
        <label class="menunamestyle">{{this.$session.get("MENUNAME")}}</label>
      </v-col>
      <v-spacer/>      
      <template v-if="grade >= 50">
      <v-col  cols="12" offset-md="1" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <comdialog :comname="SEARCH_COM_NAME" @cancelcallback="comsearchclear" @callback="comsearchcb"></comdialog>
      </v-col>
      </template>
      <v-col cols="12" md="3" sm="12" xs="12"  class="pa-0" align="center">
        <eventdialog :eventname="SEARCH_EVENT_NAME" :comidx="SEARCH_COM_IDX" @callback="eventsearchcb"></eventdialog>
      </v-col>

      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" outlined large @click="search_run">{{$t('common_search_list')}}</v-btn>
      </v-col>
      <v-col cols="6" md="1" sm="6" xs="6" class="pa-0" align="center">
        <v-btn style="width:98%" class="search_btn_freesize" elevation="0" outlined large @click="newinsert">{{$t("common_insert")}}</v-btn>
      </v-col>
    </v-row>
    
  <v-row dense no-gutters>
    <label class="total_label">{{$t("common_total")}}</label><label class="total_label">{{totalcnt}}</label>
  </v-row>

  <v-row align="start">
    <v-col>
      <!-- 테이블 -->
      <v-data-table
        :headers="headers"
        :items="itemList"
        :no-data-text="$t('common_nodata')"
        hide-default-footer
        
        class="datatablestyle"
        item-key="IDX"
        :loading="loading"
        :items-per-page="9999"
        >
        <template v-slot:header.DAYDATE>
          <label class="cheader_normal" >{{$t("edpoint_col1")}}</label>
        </template>
        <template v-slot:header.POINT>
          <label class="cheader_normal" >{{$t("edpoint_col2")}}</label>
        </template>
        <template v-slot:header.POINTPERMIN>
          <label class="cheader_normal" >{{$t("edpoint_col3")}}</label>
        </template>
        <template v-slot:header.DAYMAX>
          <label class="cheader_normal" >{{$t("edpoint_col4")}}</label>
        </template>
        <template v-slot:header.ESSENMAX>
          <label class="cheader_normal" >{{$t("edpoint_col5")}}</label>
        </template>
        <template v-slot:header.POINTMAX>
          <label class="cheader_normal" >{{$t("edpoint_col6")}}</label>
        </template>
        <template v-slot:header.actions>
          <label class="cheader_normal" >{{$t("edpoint_col7")}}</label>
        </template>

        <template v-slot:item.actions="{ item }">  
            <v-icon class="mr-2" small @click="edit_item(item)">mdi-pencil</v-icon>
            <v-icon small @click="delete_item(item)">mdi-delete</v-icon>
        </template>     
      </v-data-table>
    </v-col>
  </v-row>

  </v-container>
</template>

<script>
import moment from 'moment'
export default {

    data: () => ({
      
      date1:false,
      totalcnt : 0,       //전체 아이템 개수

      //필수 페이징 파라메터
      loading : false,    //로딩 표시

      //CRUD 관련
      dialogTitle: '추가하기',   //다이얼로그 제목
      editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
      dialog:false,
      defaultItem: {
          POINT: 1,
          POINTPERMIN: 60,
          DAYMAX: 6,
          POINTMAX: 4,
          ESSENMAX: 2,
          DAYDATE:null
      },
      editedItem: {
      },
      

      //테이블 정의
      headers: [
        {text: '날짜',    value: 'DAYDATE', sortable: true, align:'center' },
        {text: '기준평점',    value: 'POINT', sortable: true, align:'center'},
        {text: '획득기준(분)',    value: 'POINTPERMIN', sortable: true, align:'center'},
        {text: '일최대 종합평점',    value: 'DAYMAX', sortable: true, align:'center'},
        {text: '일최대 필수평점',    value: 'ESSENMAX', sortable: true, align:'center'},
        {text: '일최대 일반평점',    value: 'POINTMAX', sortable: true, align:'center'},
        {text: '수정/삭제', value: 'actions', sortable: false, align:'center'}
      ],
      itemList: [],
      
      SEARCH_COM_IDX: null,
      SEARCH_COM_NAME: '',
      SEARCH_EVENT_IDX: null,
      SEARCH_EVENT_NAME: '',
      grade : 0,

    }),

    mounted(){

      if(this.$session.get("GRADE") < 10){
        this.$alert(this.$t("common_nograde"));
        this.$router.push("Login");
        return;
      }

      this.SEARCH_COM_IDX    = this.$session.get("COM_IDX");
      this.SEARCH_COM_NAME   = this.$session.get("COM_NAME");
      this.SEARCH_EVENT_IDX  = this.$session.get("EVENT_IDX");
      this.SEARCH_EVENT_NAME = this.$session.get("EVENT_NAME");
      this.grade = this.$session.get("GRADE");

      if(this.$session.exists("ADMIN_IDX")){
        this.initpage();
      }else{
        //키값 없으면 로그인으로
        this.$router.push("Login");
      }
    },

    create(){

    },

    methods: {

      loadpage(){

        if(this.SEARCH_COM_IDX == null){
          this.$alert(this.$t('common_select_tcom'));
          return;
        }
        if(this.SEARCH_EVENT_IDX == null){
          this.$alert(this.$t('common_select_tevent'));
          return;
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화

        this.loading = true;

          this.$http.post(this.$host+'/api/EventDayPointList',{
                ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              const list = result.data.resultData;
              list.forEach(element => {
                  this.itemList.push(element); 
              });
              this.totalcnt = this.itemList.length;
              this.loading = false;

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.loading = false;
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
              this.loading = false;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
          });

      },

      initpage(){
        //첫페이지 로드
        this.loadpage();
      },      

      //다이얼로그 닫기
      close () {
        this.dialog     = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      //url의 마지막 /이후의 값을 가져온다.
      async getLastPath(path_url){
        var array = path_url.split('/');
        return array[array.length-1];
      },

      //추가 저장
      async save () {
        
        const pointVal = /[^0-9]/g;
        if(this.editedItem.POINT  == undefined || this.editedItem.POINT.length < 1){
          this.$alert(this.$t('edpoint_label2'));
          return;
        } 
        if(this.editedItem.POINT.length > 4){
          this.$alert(this.$t('edpoint_label3'));
          return;
        } 
        if(pointVal.test(this.editedItem.POINT)){
          this.$alert(this.$t('edpoint_label4'));
          return;
        } 

        if(this.editedItem.POINTPERMIN  == undefined || this.editedItem.POINTPERMIN.length < 1){
          this.$alert(this.$t('edpoint_label5'));
          return;
        } 
        if(this.editedItem.POINTPERMIN.length > 4){
          this.$alert(this.$t('edpoint_label6'));
          return;
        } 
        if(pointVal.test(this.editedItem.POINTPERMIN)){
          this.$alert(this.$t('edpoint_label7'));
          return;
        } 

        if(this.editedItem.DAYMAX  == undefined || this.editedItem.DAYMAX.length < 1){
          this.$alert(this.$t('edpoint_label8'));
          return;
        } 
        if(this.editedItem.DAYMAX.length > 4){
          this.$alert(this.$t('edpoint_label9'));
          return;
        } 
        if(pointVal.test(this.editedItem.DAYMAX)){
          this.$alert(this.$t('edpoint_label10'));
          return;
        } 


        if(this.editedItem.POINTMAX  == undefined || this.editedItem.POINTMAX.length < 1){
          this.$alert(this.$t('edpoint_label11'));
          return;
        } 
        if(this.editedItem.POINTMAX.length > 4){
          this.$alert(this.$t('edpoint_label12'));
          return;
        } 
        if(pointVal.test(this.editedItem.POINTMAX)){
          this.$alert(this.$t('edpoint_label13'));
          return;
        } 

        if(this.editedItem.ESSENMAX  == undefined || this.editedItem.ESSENMAX.length < 1){
          this.$alert(this.$t('edpoint_label14'));
          return;
        } 
        if(this.editedItem.ESSENMAX.length > 4){
          this.$alert(this.$t('edpoint_label15'));
          return;
        } 
        if(pointVal.test(this.editedItem.ESSENMAX)){
          this.$alert(this.$t('edpoint_label16'));
          return;
        } 

        if (this.editedIndex > -1) {

          //수정
          this.loading = true;
          this.$http.post(this.$host+'/api/EventDayPointUpdate',{
                COM_IDX: this.editedItem.COMIDX
              , ADMIN_IDX: this.editedItem.ADMIN_IDX
              , EVENT_IDX: this.editedItem.EVENT_IDX
              , DAYDATE: this.editedItem.DAYDATE
              , DAYMAX: this.editedItem.DAYMAX
              , POINTMAX: this.editedItem.POINTMAX
              , ESSENMAX: this.editedItem.ESSENMAX
              , POINTPERMIN: this.editedItem.POINTPERMIN
              , POINT: this.editedItem.POINT
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              this.close();
              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }
                this.$alert(this.$t("common_edit_msg")).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동

            }else{
                this.$alert(this.$t("common_edit_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_edit_fail"));
          });


        }else{

          //신규
          this.loading = true;
          this.$http.post(this.$host+'/api/EventDayPointInsert',{
                DAYDATE: this.editedItem.DAYDATE
              , DAYMAX: this.editedItem.DAYMAX
              , POINTMAX: this.editedItem.POINTMAX
              , ESSENMAX: this.editedItem.ESSENMAX
              , POINTPERMIN: this.editedItem.POINTPERMIN
              , POINT: this.editedItem.POINT
              , ADMIN_IDX: this.$session.get("ADMIN_IDX")
              , COM_IDX: this.SEARCH_COM_IDX
              , EVENT_IDX: this.SEARCH_EVENT_IDX
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){
              
              this.close();

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

                this.$alert(this.$t('common_insert_msg')).then(()=>{
                  this.loadpage();
                });

            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else if(result.data.resultCode == 3){
              this.$alert(this.$t('edpoint_label17'));
            }else{
              this.$alert(this.$t("common_insert_fail"));
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
            this.loading = false;
            this.$alert(this.$t("common_insert_fail"));
          });


        }

      },      

      //검색
      search_run(){
        this.loadpage();
      },
      
      //신규 추가
      newinsert(){

        this.dialogTitle = this.$t('common_insert_title');
        this.editedIndex  = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.DAYDATE     = moment().format("YYYY-MM-DD");
        this.editedItem.COM_IDX     = this.SEARCH_COM_IDX;
        this.editedItem.COM_NAME    = this.SEARCH_COM_NAME;
        this.editedItem.EVENT_IDX   = this.SEARCH_EVENT_IDX;
        this.editedItem.EVENT_NAME  = this.SEARCH_EVENT_NAME

        this.dialog = true;
      },

      //아이템 수정
      edit_item(item){
        this.dialogTitle = this.$t('common_edit_title');
        this.editedIndex = this.itemList.indexOf(item)
        //this.editedItem = item;
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      //아이템 삭제
      delete_item(item){

        this.$confirm(this.$t("common_delete_msg"))
        .then(() => {
          this.loading = true;
          this.$http.post(this.$host+'/api/EventDayPointDelete',{
              ADMIN_IDX:item.ADMIN_IDX
            , COM_IDX:item.COMIDX
            , EVENT_IDX:item.EVENT_IDX
            , DAYDATE:item.DAYDATE
          },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
          .then((result)=>{
            this.loading = false;
            if(result.data.resultCode == 0){

              //토큰 저장
              if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
              }
              if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
              }

              this.$alert(this.$t("common_delete_com")).then(()=>{
                this.loadpage();
              });
              
            }else if(result.data.resultCode == 2){
              //로그인 필요
              this.$alert(this.$t("common_tokener"));
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.$router.push('Login');   //로그인 페이지로 이동
              
            }else{
              this.$alert(this.$t("common_delete_fail"));
            }
            
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error)=>{
              this.loading = false;
              this.$alert(this.$t("common_delete_error"));
          });      

        });

      },

      //업체선택 콜백
      comdialogcb(val){
        if(val.NAME.length > 0){
          this.editedItem.COM_NAME = val.NAME;
          this.editedItem.COM_IDX  = val.IDX;
        }else{
          this.$alert(this.$t('common_select_company'));
          return;
        }
      },

      //검색조건 업체 설정
      comsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_COM_NAME = val1.NAME;
          this.SEARCH_COM_IDX  = val1.IDX;
          this.$session.set("COM_IDX", val1.IDX);
          this.$session.set("COM_NAME", val1.NAME);
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }else{
          this.SEARCH_COM_NAME = '';
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_EVENT_IDX = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }

        this.itemList.splice(0, this.itemList.length);   //데이터 초기화
        
      },

      //검색조건 업체 설정
      eventsearchcb(val1){
        if(val1.NAME.length > 0){
          this.SEARCH_EVENT_NAME = val1.NAME;
          this.SEARCH_EVENT_IDX  = val1.IDX;
          this.$session.set("EVENT_IDX", val1.IDX);
          this.$session.set("EVENT_NAME",val1.NAME);
        }else{
          this.SEARCH_EVENT_NAME = "";
          this.SEARCH_EVENT_IDX  = null;
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
        }
        this.loadpage();
      },

      // eslint-disable-next-line no-unused-vars
      comsearchclear(var2){
          this.SEARCH_COM_IDX    = null;
          this.SEARCH_COM_NAME   = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");

          this.itemList.splice(0, this.itemList.length);   //데이터 초기화
          

      },

    },
  
}
</script>

<!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
<style scoped>

</style>